export default {
  // Cover
  coverCompanyTitle: 'Our Company',
  coverCompanySlogan: 'One-liner slogan',
  coverCompanyDescription: 'Who we are. How we can help you. And how we are different from others.',
  coverCompanyBtnLabel: 'Call us now',

  // Benefits
  benefitBlockTitle: 'Benefit Title',
  benefitBlockSlogan: 'A catchy one-liner subheader',
  benefitListTitle: 'Our Benefits',

  benefitItemTitle: 'Benefit Title',
  benefitItemDescriptionShort:
    'What\'s in it for them? ' +
    'Focus on their benefits instead of product-features. ' +
    'Keep it short and make it sound fun.',
  benefitItemDescription:
    'What\'s in it for them? ' +
    'Explain how you will add value to your customers. ' +
    'Make it about them. Focus on the benefits, and avoid describing features. ' +
    'People hate long texts. So keep it short.',

  // Call to action
  ctaBlockTitle: 'Are you ready?',
  ctaBlockSlogan: 'A compelling event / limited-time offer / slogan',

  ctaPrimaryTitle: 'Primary CTA',
  ctaPrimaryDescription:
    'Explain the purpose of this primary call-to-action. ' +
    'Set expectations for your visitors by specifying the next steps.',
  ctaPrimaryBtnLabel: 'Primary button',

  ctaSecondaryTitle: 'Secondary CTA',
  ctaSecondaryDescription:
    'Explain the purpose of this secondary call-to-action. ' +
    'Set expectations for your visitors by specifying the next steps.',
  ctaSecondaryBtnLabel: 'Secondary button',

  // Contact
  contactBlockTitle: 'Contact Us',
  contactBlockSlogan: 'Get in touch with us',
  contactDescription:
    'Respect privacy expectations by being transparent about usage of user-submitted data. ' +
    'Let them know the next steps. ' +
    'And set timeline expectations too, if any.',
  contactAddressTitle: 'Address',
  contactAddressDummy: 'Lorem Ipsum Ave<br />Amet Dummy Pin Dummy place<br />Phone : 1-800-123-4567<br />Email: info@dummy.com',
  contactPhoneTitle: 'Phone',
  contactPhoneDummy: '1-800-123-4567',
  contactEmailTitle: 'Email',
  contactEmailDummy: 'info@dummy.com',
  contactSubmitLabel: 'Submit',
  contactResetLabel: 'Reset',

  testimonialBlockTitle: 'Our Testimonials',

  testimonialDummy: '',
  testimonialMaleName: 'John Doe',
  testimonialMalePic: 'https://lh3.googleusercontent.com/fLhUtF6inkFG16iFaEUzNZmQT_XDZHRkwre272KW0z9tQ9HCeupoKNmFuZuMVK3F3BaQFBdFvDoaBZ5GtCdMIw',
  testimonialMaleTitle: 'Product Manager, Acme Inc.',
  testimonialFemaleName: 'Jane Doe',
  testimonialFemalePic: 'https://lh3.googleusercontent.com/3npkRYkE-lgjteOiXYdeGlHQ3Wn7HXc6OpZ9ksXBVTm-_EUQflekV8-dBkxbHMh2fccw_owBiYsRjAq4R9Ao0w',
  testimonialFemaleTitle: 'VP Operations, Acme Inc.',
  testimonialSample: 'Add social proof by adding a direct quote from an existing client or well-wisher. You can also use this space for sharing case-studies or powerful stories that people can relate to.',

  pricingSingleAmount: '$9',
  pricingSinglePer: 'per month',
  pricingSingleHeader: 'Your plan includes',
  pricingSingleFeatures: 'Feature #1<br />Feature #2<br />Feature #3<br />Feature #4<br />more...',

  pricingColumnTitle: 'Our pricing',
  pricingColumnSlogan: 'A plan for every need',
  pricingColumnFeatures: 'Feature #1<br />Feature #2<br />more...',
};



// WEBPACK FOOTER //
// ./scripts/components/editor/blocks/phrases.js